<template>
    <section v-if="pageLoader" class="horoscope-page">
        {{ $t("loading.loading") }}
    </section>
    <section v-else class="horoscope-page">
        <h1 class="heading container-mobile">
            {{ $t("horoscope.horoscopeToday") }}
        </h1>
        <ul class="horoscope-list container-mobile">
            <!-- <li v-for="sign in horoscope" :key="sign.id" class="horoscope-item">
                <div class="horoscope-aside" :class="'horoscope-' + horoscopeLocal[sign.id - 1].key">
                    <div class="horoscope-name">{{ sign.title }}</div>
                    <div class="horoscope-date" v-html="horoscopeLocal[sign.id - 1].date"></div>
                </div>
                <div class="horoscope-text" v-html="sign.text"></div>
            </li> -->
            <li v-for="sign in horoscope" :key="sign.id" class="horoscope-item">
                <div class="horoscope-aside" :class="'horoscope-' + horoscopeLocal[sign.id - 1].key">
                    <div class="horoscope-name" v-html="getCurrentTitle(sign)"></div>
                    <div class="horoscope-date" v-html="horoscopeLocal[sign.id - 1].date"></div>
                </div>
                <div class="horoscope-text" v-html="getCurrentText(sign)"></div>
            </li>

        </ul>
    </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Horoscope",
    props: {
        i18n: Object,
    },
    data() {
        return {
            pageLoader: true,
            horoscopeLocal: [
                {
                    key: "aries",
                    date: this.$t("horoscope.aries"),
                },
                {
                    key: "taurus",
                    date: this.$t("horoscope.taurus"),
                },
                {
                    key: "gemini",
                    date: this.$t("horoscope.gemini"),
                },
                {
                    key: "cancer",
                    date: this.$t("horoscope.cancer"),
                },
                {
                    key: "leo",
                    date: this.$t("horoscope.leo"),
                },
                {
                    key: "virgo",
                    date: this.$t("horoscope.virgo"),
                },
                {
                    key: "libra",
                    date: this.$t("horoscope.libra"),
                },
                {
                    key: "scorpio",
                    date: this.$t("horoscope.scorpio"),
                },
                {
                    key: "sagittarius",
                    date: this.$t("horoscope.sagittarius"),
                },
                {
                    key: "capricorn",
                    date: this.$t("horoscope.capricorn"),
                },
                {
                    key: "aquarius",
                    date: this.$t("horoscope.aquarius"),
                },
                {
                    key: "pisces",
                    date: this.$t("horoscope.pisces"),
                },
            ],
            selectedLanguage: "",
        };
    },
    computed: {
        ...mapGetters({
            horoscope: "horoscope/fetchHoroscope",
        }),
    },
    mounted() {
        this.selectedLanguage = localStorage.getItem("locale") || "ru"; // По умолчанию "ru"
        // console.log("Selected Language:", this.selectedLanguage);
        document.getElementsByTagName("body")[0].classList.add("horoscope");
    },
    created() {
        this.getHoroscope();
    },
    beforeDestroy() {
        document.getElementsByTagName("body")[0].classList.remove("horoscope");
    },
    methods: {
        getCurrentText(sign) {
            const languageKeyMap = {
                ru: "text",
                en: "text_en",
                tr: "text_tr",
                es: "text_es",
                fr: "text_fr",
            };
            // Проверяем, какой язык выбран в localStorage
            const selectedLang = localStorage.getItem("locale");
            // Определяем ключ, который нужно использовать
            const dataKey = languageKeyMap[selectedLang] || "text";
            // Возвращаем соответствующий текст
            return sign[dataKey];
        },
        getCurrentTitle(sign) {
            const languageKeyMap = {
                ru: "title",
                en: "title_en",
                tr: "title_tr",
                es: "title_es",
                fr: "title_fr",
            };
            const selectedLang = localStorage.getItem("locale");
            const dataKey = languageKeyMap[selectedLang] || "title";
            return sign[dataKey];
        },
        getHoroscope() {
            this.$store
                .dispatch("horoscope/get")
                .then(() => {
                    this.pageLoader = false;
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
    },
};
</script>

<style lang="scss">
@import "~@/assets/styles/pages/_horoscope";
</style>
